import React from 'react';
import ReactDOM from 'react-dom';

import {
  CommonFeatureFlagsType,
  CommonPortalCapabilities,
  CommonPricingPlanFeatures,
  ExtraLayoutType,
  ModalsType,
  RoutesMap,
  TenantType,
} from '@portals/types';
import { initSentry } from '@portals/utils';

import { App } from './App';
import ErrorBoundary from './Error';
import modals from './modals';
import './external/google_maps';

import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';

let renderedApp: null | 'desktop' | 'mobile' = null;

function start<
  TFeatureFlags extends CommonFeatureFlagsType,
  TPortalCapabilities extends CommonPortalCapabilities,
  TPricingPlanFeatures extends CommonPricingPlanFeatures
>(
  routes: RoutesMap<TFeatureFlags, TPortalCapabilities, TPricingPlanFeatures>,
  customModals: ModalsType = {},
  tenantType: TenantType,
  extraLayout?: ExtraLayoutType<TFeatureFlags>,
  type: 'desktop' | 'mobile' = 'desktop'
) {
  initSentry();

  const params = new URLSearchParams(document.location.search);
  const existingAuth = params.get('auth');

  if (existingAuth) {
    try {
      // Parsing first to catch errors
      const auth = JSON.parse(atob(existingAuth));

      localStorage.setItem('auth', JSON.stringify(auth));

      window.location.assign('/');
    } catch (err) {
      console.error(err);
    }
  }

  if (process.env.NX_GIT_LATEST_COMMIT_SHA) {
    console.log(
      `Current portal version: ${process.env.NX_GIT_LATEST_COMMIT_SHA}`
    );
  }

  // When switching between desktop/mobile views, we want to re-render entirely the app
  if (renderedApp && renderedApp !== type) {
    ReactDOM.unmountComponentAtNode(document.getElementById('root'));
  }

  renderedApp = type;

  ReactDOM.render(
    <ErrorBoundary>
      <App<TFeatureFlags, TPortalCapabilities, TPricingPlanFeatures>
        routes={routes}
        modals={{ ...modals, ...customModals }}
        tenantType={tenantType}
        extraLayout={extraLayout}
      />
    </ErrorBoundary>,
    document.getElementById('root')
  );
}

export default start;
